// extracted by mini-css-extract-plugin
export default {"main_wallet_info":"LogIn_main_wallet_info__pNQnN","clickable_main_wallet":"LogIn_clickable_main_wallet__DFFZm","log_in":"LogIn_log_in__mQ8Fc"};